import { InsulationElement } from "./InsulationElement";
import { InsulationElementType } from "../../constants/combo/InsulationElementType";
export class BasementWallElement extends InsulationElement {
  getElementType = () => InsulationElementType.BASEMENT_WALL;
  getMaxWidth = () => 50.0;
}
